import {
  useAnimationStore,
  usePlayersStore,
} from "@/stores";
export function handleChatActivity(params: { from: string; to: string }) {
  const playersStore = usePlayersStore();
  const animationStore = useAnimationStore();

  const fromPlayer = playersStore.getById(params.from);
  const toPlayer = playersStore.getById(params.to);
  if (fromPlayer && toPlayer) {
    const fromIndex = playersStore.players.indexOf(fromPlayer);
    const toIndex = playersStore.players.indexOf(toPlayer);
    animationStore.addAnimation({
      from: fromIndex,
      to: toIndex,
      emoji: "✉️",
    });
  }
}
